import { useAuth } from "react-oidc-context";
import { useTranslation } from "react-i18next";

const AuthContent = () => {
  const auth = useAuth();
  const { t } = useTranslation();

  return (
    <main className="min-h-screen flex items-center justify-center bg-[#f5f6f6]">
      <div className="flex flex-col items-center gap-6 p-8 bg-white rounded-lg shadow-lg">
        <div className="flex flex-col items-center gap-2">
          <h1 className="text-2xl font-bold text-vcolor">
            {t("login.portal")}
          </h1>
          <p className="text-gray-600">{t("login.access")}</p>
        </div>
        <button
          type="button"
          onClick={() => void auth.signinRedirect()}
          className="px-6 py-3 bg-vcolor text-white rounded-md hover:bg-vcolor-hover transition-colors duration-200 font-medium"
        >
          {t("login.action")}
        </button>
      </div>
    </main>
  );
};

export default AuthContent;
